export enum TaskActionType {
  Perform = 'Perform',
  Postpone = 'Postpone',
  Update = 'Update',
  Create = 'Create',
  Legacy = 'Legacy',
}
